import styled, { css } from 'react-emotion'
import {
  space,
  width,
  fontSize,
  color,
  justifyContent,
  responsiveStyle,
  alignItems,
  textAlign,
  fontWeight,
} from 'styled-system'
import GatsbyLink from 'gatsby-link'
import React from 'react'

export const wrap = responsiveStyle({
  prop: 'wrap',
  cssProperty: 'flexWrap',
})

export const maxWidth = responsiveStyle({
  prop: 'maxWidth',
  cssProperty: 'maxWidth',
})
export const display = responsiveStyle({
  prop: 'display',
  cssProperty: 'display',
})
export const height = responsiveStyle({
  prop: 'height',
  cssProperty: 'height',
})

export const Box = styled.div`
  display: flex;
  flex-direction: column;
  ${maxWidth} ${space} ${width} ${fontSize} ${color} ${alignItems};
`

export const Flex = styled.div`
  display: flex;
  ${alignItems} ${maxWidth} ${justifyContent} ${wrap} ${space} ${width} ${fontSize} ${fontWeight} ${color};
`

export const P = styled.p`
  ${maxWidth} ${textAlign} ${space} ${width} ${fontSize} ${fontWeight} ${color};
`

export const H1 = styled.h1`
  ${maxWidth} ${textAlign} ${space} ${width} ${fontSize} ${fontWeight} ${color};
`

export const H2 = styled.h1`
  ${maxWidth} ${textAlign} ${space} ${width} ${fontSize} ${fontWeight} ${color};
`
export const Link = styled(GatsbyLink)`
  ${maxWidth} ${textAlign} ${space} ${width} ${fontSize} ${fontWeight} ${color};
`
export const Img = styled.img`
  ${maxWidth} ${textAlign} ${space} ${width} ${fontSize} ${fontWeight} ${color};
`

export const SemanticList = styled.ul`
  display: flex;
  list-style: none;
  ${display} ${maxWidth} ${alignItems} ${justifyContent} ${space} ${width} ${fontSize} ${fontWeight} ${color};
`

export const Nav = styled.nav`
  display: flex;
  ${display} ${maxWidth} ${alignItems} ${justifyContent} ${space} ${width} ${fontSize} ${fontWeight} ${color};
`

export const Li = styled.li`
  ${display} ${maxWidth} ${alignItems} ${justifyContent} ${space} ${width} ${fontSize} ${fontWeight} ${color};
`

export const Input = styled.input`
  ${height} ${display} ${maxWidth} ${alignItems} ${justifyContent} ${space} ${width} ${fontSize} ${fontWeight} ${color};
`

export const A = styled.a`
  ${maxWidth} ${textAlign} ${space} ${width} ${fontSize} ${fontWeight} ${color};
`

export const FlexibleLink = ({ to, children, href, ...props }) => {
  if (to) {
    return (
      <Link to={to} {...props}>
        {children}
      </Link>
    )
  } else {
    return (
      <A href={href} {...props}>
        {children}
      </A>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Layout/index.js